/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { api } from './api';

interface IAdminGymListItem {
  id: string;
  name: string;
  domain: string;
  logo_url: string | null;
  signature: string;
  is_active: boolean;
}

interface IAdminGymFeatureAddon {
  id: string;
  value: number | null;
  price: number;
}

interface IAdminGymFeatureCategory {
  code: string;
  label: string;
  icon: string;
  order: number;
}

interface IAdminGymFeature {
  feature_id: string;
  nome: string;
  code: string;
  plan_value: number | null;
  addon_value: number | null;
  effective_value: number | null;
  addons: IAdminGymFeatureAddon[];
  category: IAdminGymFeatureCategory | null;
  default_addon_value: number | null;
  default_addon_price: number | null;
}

interface IAdminGymFeaturesDetail {
  gym: IAdminGymListItem;
  plan_name: string;
  can_grant_addons: boolean;
  plan_price: number;
  addons_price_total: number;
  total_price: number;
  features: IAdminGymFeature[];
}

class AdminGymFeaturesService {
  private apiService = api;

  public async getGymFeatures(gym_id: string) {
    return this.apiService.get<IAdminGymFeaturesDetail>(
      `admin/gyms/${gym_id}/features`,
    );
  }

  public async grantFeature(
    gym_id: string,
    feature_id: string,
    value: number | null,
    price?: number,
  ) {
    return this.apiService.put(
      `admin/gyms/${gym_id}/features/${feature_id}`,
      { value, price },
    );
  }

  public async revokeFeature(gym_id: string, feature_id: string) {
    return this.apiService.delete(
      `admin/gyms/${gym_id}/features/${feature_id}`,
    );
  }

  public async addAddon(
    gym_id: string,
    feature_id: string,
    value: number | null,
    price: number,
  ) {
    return this.apiService.post(
      `admin/gyms/${gym_id}/features/${feature_id}/addons`,
      { value, price },
    );
  }

  public async removeAddon(gym_id: string, addon_id: string) {
    return this.apiService.delete(`admin/gyms/${gym_id}/addons/${addon_id}`);
  }
}

export { AdminGymFeaturesService };
export type {
  IAdminGymListItem,
  IAdminGymFeature,
  IAdminGymFeatureAddon,
  IAdminGymFeatureCategory,
  IAdminGymFeaturesDetail,
};
